import { FormattedMessage } from "react-intl";
import { MdPayments } from "react-icons/md";
import { AiFillApi } from "react-icons/ai";
import { FaUserTie } from "react-icons/fa";
import { TbAdjustmentsCog } from "react-icons/tb";

import { SharedContextProps } from "@lib/types";
import { AppTabProps } from "@lib/components/AppComponents/AppTabs";
import {
  SharedPaymentHistory,
  SharedManagers,
  SharedPaymentIntegrations,
  SharedPaymentTransactionConfigs,
} from "@app/shared";

export const getPaymentProviderDetailTabs =
  (): AppTabProps<SharedContextProps>[] => [
    {
      key: "paymentHistory",
      Title: <FormattedMessage id={"common.paymentHistory"} />,
      Icon: <MdPayments />,
      Component: SharedPaymentHistory,
    },
    {
      key: "paymentTransactionConfigs",
      Title: <FormattedMessage id={"common.paymentTransactionConfigs"} />,
      Icon: <TbAdjustmentsCog />,
      Component: SharedPaymentTransactionConfigs,
    },
    {
      key: "integrations",
      Title: <FormattedMessage id={"common.paymentIntegrations"} />,
      Icon: <AiFillApi />,
      Component: SharedPaymentIntegrations,
    },
    {
      key: "systemUsers",
      Title: <FormattedMessage id={"common.systemUsers"} />,
      Icon: <FaUserTie />,
      Component: SharedManagers,
    },
  ];
